// Detect a SKEECH within a single turn: 3 distinct point buckets hit and the 4th in any bucket
export function isSkeechTurn(hits: number[]): boolean {
  if (hits.length < 4) return false;
  const counts = new Map<number, number>();
  for (const h of hits) counts.set(h, (counts.get(h) || 0) + 1);
  const distinct = Array.from(counts.keys());
  return distinct.length >= 3 && hits.length >= 4;
}

export function getSkeechWildcard(hits: number[]): number | null {
    if (!isSkeechTurn(hits) || hits.length < 4) return null;

    const required = new Set([1, 3, 5]);
    const counts = new Map<number, number>();
    for (const h of hits) counts.set(h, (counts.get(h) || 0) + 1);

    let wildcard: number | null = null;
    counts.forEach((count, num) => {
        if (count > 1 && required.has(num)) {
            wildcard = num;
        }
        if (!required.has(num)) {
            wildcard = num;
        }
    });

    return wildcard;
}
